import { Component, OnInit } from '@angular/core';
import { PrivacyPolicyComponent } from 'src/app/shared/modal/privacy-policy/privacy-policy.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-term-and-insurance',
  templateUrl: './term-and-insurance.component.html',
  styleUrls: ['./term-and-insurance.component.scss']
})
export class TermAndInsuranceComponent implements OnInit {

  constructor(
    public TCDialogue: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  onClickPP(){
    this.TCDialogue.open(PrivacyPolicyComponent);
  }

}
